import { ClientData } from '../../models/base/client-data';

export type ClientsState = {
  clients: {
    [clientCode: string]: ClientData;
  };
};

export const initialClientsState: ClientsState = {
  clients: null,
};
